import {deviceTypeConstants} from "../constants/device-type-constants";
import {deviceTypeService} from "../services/device-type.service";
import {alertActions} from "./alert.actions";
import {modalActions} from "./modal.actions";

const getDeviceTypeList = () => {
    return dispatch => {
        // dispatch({ type: deviceTypeConstants.DEVICE_TYPE_LIST_REQUEST })
        deviceTypeService.getList()
            .then(
                deviceTypeModel => {
                    dispatch({type: deviceTypeConstants.DEVICE_TYPE_LIST_SUCCESS, deviceTypeModel})
                },
                error => {
                    dispatch({type: deviceTypeConstants.DEVICE_TYPE_LIST_FAILURE, error})
                }
            )
    };
};

const getDropDownList = () => {
    return dispatch => {
        dispatch({type: deviceTypeConstants.DEVICE_TYPE_DROPDOWN_REQUEST});
        deviceTypeService.getDropDownList()
            .then(
                dropdown => {
                    dispatch({type: deviceTypeConstants.DEVICE_TYPE_DROPDOWN_SUCCESS, dropdown})
                },
                error => {
                    dispatch({type: deviceTypeConstants.DEVICE_TYPE_DROPDOWN_FAILURE, error})
                },
            );
    }
};

const addDeviceType = (deviceTypeModel) => {
    return dispatch => {
        deviceTypeService.addDeviceType(deviceTypeModel)
            .then(
                (res) => {
                    dispatch(getDeviceTypeList());
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch(alertActions.error(error));
                }
            )
    }
};

const editDeviceType = (deviceTypeModel) => {
    return dispatch => {
        deviceTypeService.editDeviceType(deviceTypeModel)
            .then(
                (res) => {
                    dispatch(getDeviceTypeList());
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch(alertActions.error(error));
                }
            )
    }
};

const deleteDeviceType = (deviceTypeId) => {
    return dispatch => {
        deviceTypeService.deleteDeviceType(deviceTypeId)
            .then(
                (res) => {
                    dispatch(getDeviceTypeList());
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch(alertActions.error(error));
                }
            )
    }
};

export const deviceTypeActions = {
    getDeviceTypeList,
    getDropDownList,
    addDeviceType,
    editDeviceType,
    deleteDeviceType
};
